export const QA_NAME_ENTITY_PROFILE_NAVIGATION_PREV =
  'entityProfileNavigationPrev'

export const QA_NAME_ENTITY_PROFILE_NAVIGATION_NEXT =
  'entityProfileNavigationNext'

export const ENTITY_PROFILE_NAVIGATION_BASE_VALUE = 0
